export const removeFileExtension = (fileName: string) => fileName.replace(/\.[^/.]+$/, '');